import {
  RiFileCodeFill,
  RiFileExcel2Fill,
  RiFilePdf2Fill,
  RiFileTextFill,
  RiMicrosoftFill
} from '@remixicon/react'

import type { FileType } from '../types'
import { urlPath } from '@/utils/url'

export const getMimeTypeFromUrl = (url: string) => {
  // Read the extension from the path: presigned links end in ?X-Amz-...
  const ext = urlPath(url).split('.').pop()?.toLowerCase()
  switch (ext) {
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg'
    case 'png':
      return 'image/png'
    case 'pdf':
      return 'application/pdf'
    case 'csv':
      return 'text/csv'
    case 'txt':
      return 'text/plain'
    case 'msg':
      return 'application/vnd.ms-outlook'
    case 'xml':
      return 'application/xml'
    case 'heic':
      return 'image/heic'
    case 'heif':
      return 'image/heif'
    default:
      return ''
  }
}

export const getFileType = (url: string, mimeType: string): FileType => {
  const lower = urlPath(url).toLowerCase()
  if (lower.endsWith('.msg')) return 'msg'
  if (lower.includes('.csv')) return 'csv'
  if (lower.includes('.txt')) return 'txt'
  if (lower.includes('.pdf')) return 'pdf'
  if (lower.includes('.xls') || mimeType.includes('spreadsheet') || mimeType.includes('excel')) return 'excel'
  if (lower.endsWith('.xml') || mimeType.includes('xml')) return 'xml'
  if (lower.endsWith('.heic') || lower.endsWith('.heif')) return 'image'
  if (mimeType.startsWith('image/')) return 'image'
  return 'other'
}

export const getFileIcon = (fileType: FileType) => {
  switch (fileType) {
    case 'msg':
      return <RiMicrosoftFill className='text-grey-400 size-8' />
    case 'pdf':
      return <RiFilePdf2Fill className='text-grey-400 size-8' />
    case 'excel':
      return <RiFileExcel2Fill className='text-grey-400 size-8' />
    case 'xml':
      return <RiFileCodeFill className='text-grey-400 size-8' />
    default:
      return <RiFileTextFill className='text-grey-400 size-8' />
  }
}
